// Scenery stays in schema.objects. It never generates seats or ticket inventory.
export const SCENERY_CATEGORIES = [
  { id: 'tables', name: 'Mesas' },
  { id: 'seating', name: 'Sillas y lounge' },
  { id: 'food', name: 'Gastronomía' },
  { id: 'bars', name: 'Barras y bebidas' },
  { id: 'production', name: 'Escenario y técnica' },
  { id: 'shelter', name: 'Carpas y estructuras' },
  { id: 'services', name: 'Servicios' },
  { id: 'decor', name: 'Decoración' },
  { id: 'access', name: 'Accesos y límites' },
  { id: 'activities', name: 'Experiencias' },
]
const catalog = [
  ['beer-table', 'Mesa con bancos', 'tables', 'picnic', 120, 64],
  ['table-round', 'Mesa redonda · 4', 'tables', 'round4', 120, 100],
  ['table-round-six', 'Mesa redonda · 6', 'tables', 'round6', 120, 100],
  ['table-banquet', 'Mesa banquete · 8', 'tables', 'banquet8', 120, 100],
  ['table-square', 'Mesa cuadrada', 'tables', 'square', 120, 100],
  ['table-cocktail', 'Mesa coctelera', 'tables', 'cocktail', 120, 100],
  ['table-oval', 'Mesa ovalada', 'tables', 'oval', 120, 100],
  ['table-family', 'Mesa familiar · 10', 'tables', 'family', 120, 100],
  ['table-high', 'Mesa alta con taburetes', 'tables', 'high', 120, 100],
  ['table-u', 'Mesa en U', 'tables', 'u', 120, 100],
  ['table-l', 'Mesa en L', 'tables', 'l', 120, 100],
  ['table-serpentine', 'Mesa serpentina', 'tables', 'serpentine', 120, 100],
  ['chair', 'Silla individual', 'seating', 'single', 120, 100],
  ['chair-arm', 'Sillón individual', 'seating', 'arm', 120, 100],
  ['chair-folding', 'Silla plegable', 'seating', 'folding', 120, 100],
  ['stool', 'Taburete', 'seating', 'stool', 120, 100],
  ['bench', 'Banco largo', 'seating', 'bench', 120, 100],
  ['sofa-two', 'Sofá de dos plazas', 'seating', 'sofa2', 120, 100],
  ['sofa-three', 'Sofá de tres plazas', 'seating', 'sofa3', 120, 100],
  ['sofa-corner', 'Sofá esquinero', 'seating', 'corner', 120, 100],
  ['lounge-u', 'Lounge en U', 'seating', 'u', 120, 100],
  ['chaise', 'Chaise longue', 'seating', 'chaise', 120, 100],
  ['beanbag', 'Puf redondo', 'seating', 'pouf', 120, 100],
  ['bleachers', 'Grada de tres filas', 'seating', 'bleachers', 120, 100],
  ['food-stall', 'Puesto gastronómico', 'food', 'stall', 120, 100],
  ['food-truck', 'Food truck', 'food', 'truck', 120, 100],
  ['burger-stall', 'Puesto de hamburguesas', 'food', 'burger', 120, 100],
  ['pizza-stall', 'Horno de pizza', 'food', 'pizza', 120, 100],
  ['grill', 'Parrilla abierta', 'food', 'grill', 120, 100],
  ['bakery', 'Panadería', 'food', 'bread', 120, 100],
  ['icecream-cart', 'Carrito de helados', 'food', 'icecream', 120, 100],
  ['popcorn-cart', 'Carrito de snacks', 'food', 'snacks', 120, 100],
  ['dessert-stall', 'Puesto de postres', 'food', 'cake', 120, 100],
  ['buffet', 'Buffet de servicio', 'food', 'buffet', 120, 100],
  ['food-island', 'Isla gastronómica', 'food', 'island', 120, 100],
  ['food-kitchen', 'Cocina de apoyo', 'food', 'kitchen', 120, 100],
  ['beer-bar', 'Barra cervecera', 'bars', 'beer', 120, 100],
  ['cocktail-bar', 'Barra de cócteles', 'bars', 'cocktail', 120, 100],
  ['wine-bar', 'Barra de vinos', 'bars', 'wine', 120, 100],
  ['coffee-bar', 'Barra de café', 'bars', 'coffee', 120, 100],
  ['juice-bar', 'Barra de jugos', 'bars', 'juice', 120, 100],
  ['water-station', 'Estación de agua', 'bars', 'water', 120, 100],
  ['bar-round', 'Barra circular', 'bars', 'round', 120, 100],
  ['bar-u', 'Barra en U', 'bars', 'u', 120, 100],
  ['bar-corner', 'Barra de esquina', 'bars', 'corner', 120, 100],
  ['bar-mobile', 'Barra móvil', 'bars', 'mobile', 120, 100],
  ['bar-back', 'Contrabarra', 'bars', 'back', 120, 100],
  ['bar-tasting', 'Barra de degustación', 'bars', 'tasting', 120, 100],
  ['scenery-stage', 'Escenario frontal', 'production', 'front', 120, 100],
  ['stage-round', 'Escenario circular', 'production', 'round', 120, 100],
  ['stage-runway', 'Escenario con pasarela', 'production', 'runway', 120, 100],
  ['stage-corner', 'Escenario de esquina', 'production', 'corner', 120, 100],
  ['dj-booth', 'Cabina DJ', 'production', 'dj', 120, 100],
  ['led-screen', 'Pantalla LED', 'production', 'screen', 120, 100],
  ['speaker', 'Torre de sonido', 'production', 'speaker', 120, 100],
  ['lighting-truss', 'Truss de iluminación', 'production', 'truss', 120, 100],
  ['mixing-desk', 'Control de sonido', 'production', 'mix', 120, 100],
  ['backstage', 'Camerinos', 'production', 'backstage', 120, 100],
  ['camera-platform', 'Plataforma de cámara', 'production', 'camera', 120, 100],
  ['stage-steps', 'Escalera de escenario', 'production', 'steps', 120, 100],
  ['tent-square', 'Carpa cuadrada', 'shelter', 'square', 120, 100],
  ['tent-long', 'Carpa rectangular', 'shelter', 'long', 120, 100],
  ['tent-hex', 'Carpa hexagonal', 'shelter', 'hex', 120, 100],
  ['tent-star', 'Carpa estrella', 'shelter', 'star', 120, 100],
  ['tent-dome', 'Domo', 'shelter', 'dome', 120, 100],
  ['tent-pagoda', 'Carpa pagoda', 'shelter', 'pagoda', 120, 100],
  ['tent-open', 'Carpa abierta', 'shelter', 'open', 120, 100],
  ['pergola', 'Pérgola', 'shelter', 'pergola', 120, 100],
  ['gazebo', 'Gazebo', 'shelter', 'gazebo', 120, 100],
  ['umbrella', 'Sombrilla', 'shelter', 'umbrella', 120, 100],
  ['container', 'Contenedor comercial', 'shelter', 'container', 120, 100],
  ['tent-pair', 'Carpas conectadas', 'shelter', 'pair', 120, 100],
  ['service-wc', 'Baños mixtos', 'services', 'wc', 120, 100],
  ['service-accessible', 'Baño accesible', 'services', 'accessible', 120, 100],
  ['service-medical', 'Primeros auxilios', 'services', 'medical', 120, 100],
  ['service-security', 'Puesto de seguridad', 'services', 'security', 120, 100],
  ['service-info', 'Información', 'services', 'info', 120, 100],
  ['service-tickets', 'Boletería', 'services', 'tickets', 120, 100],
  ['service-locker', 'Lockers', 'services', 'lockers', 120, 100],
  ['service-charging', 'Carga de celulares', 'services', 'charging', 120, 100],
  ['service-baby', 'Cambiador de bebés', 'services', 'baby', 120, 100],
  ['service-pet', 'Punto para mascotas', 'services', 'pet', 120, 100],
  ['service-recycle', 'Reciclaje', 'services', 'recycle', 120, 100],
  ['service-wifi', 'Punto Wi-Fi', 'services', 'wifi', 120, 100],
  ['planter', 'Jardinera redonda', 'decor', 'planter', 64, 64],
  ['planter-long', 'Jardinera rectangular', 'decor', 'long', 120, 100],
  ['tree-round', 'Árbol de copa redonda', 'decor', 'tree', 120, 100],
  ['palm', 'Palmera ornamental', 'decor', 'palm', 120, 100],
  ['flowers', 'Macetero floral', 'decor', 'flowers', 120, 100],
  ['hedge', 'Seto divisorio', 'decor', 'hedge', 120, 100],
  ['garden-island', 'Isla ajardinada', 'decor', 'island', 120, 100],
  ['fountain', 'Fuente central', 'decor', 'fountain', 120, 100],
  ['string-lights', 'Guirnalda de luces', 'decor', 'lights', 120, 100],
  ['bunting', 'Banderines', 'decor', 'bunting', 120, 100],
  ['sculpture', 'Escultura', 'decor', 'sculpture', 120, 100],
  ['photo-arch', 'Arco floral', 'decor', 'arch', 120, 100],
  ['entry-gate', 'Pórtico de entrada', 'access', 'gate', 120, 100],
  ['exit-gate', 'Pórtico de salida', 'access', 'exit', 120, 100],
  ['turnstile', 'Torniquete', 'access', 'turnstile', 120, 100],
  ['queue-lane', 'Fila de acceso', 'access', 'queue', 120, 100],
  ['barrier-metal', 'Valla metálica', 'access', 'metal', 120, 100],
  ['barrier-wood', 'Cerca de madera', 'access', 'wood', 120, 100],
  ['rope-barrier', 'Separador de cuerda', 'access', 'rope', 120, 100],
  ['fence-mesh', 'Cerramiento de malla', 'access', 'mesh', 120, 100],
  ['ramp', 'Rampa de acceso', 'access', 'ramp', 120, 100],
  ['walkway', 'Pasarela peatonal', 'access', 'walk', 120, 100],
  ['crossing', 'Cruce peatonal', 'access', 'crossing', 120, 100],
  ['bollards', 'Bolardos', 'access', 'bollards', 120, 100],
  ['dance-floor', 'Pista de baile', 'activities', 'dance', 120, 100],
  ['photo-booth', 'Fotocabina', 'activities', 'photo', 120, 100],
  ['selfie-wall', 'Muro de fotos', 'activities', 'selfie', 120, 100],
  ['brand-stand', 'Stand de marca', 'activities', 'brand', 120, 100],
  ['merch-store', 'Tienda de merchandising', 'activities', 'merch', 120, 100],
  ['kids-play', 'Juegos infantiles', 'activities', 'kids', 120, 100],
  ['ping-pong', 'Mesa de ping-pong', 'activities', 'pingpong', 120, 100],
  ['foosball', 'Futbolín', 'activities', 'foosball', 120, 100],
  ['arcade', 'Máquina arcade', 'activities', 'arcade', 120, 100],
  ['giant-chess', 'Ajedrez gigante', 'activities', 'chess', 120, 100],
  ['workshop', 'Mesa de talleres', 'activities', 'workshop', 120, 100],
  ['prize-wheel', 'Ruleta de premios', 'activities', 'wheel', 120, 100],
]
export const SCENERY_PRESETS = catalog.map(([kind, name, family, variant, w, h]) => ({ kind, name, family, variant, w, h, color: family === 'food' || family === 'decor' ? '#b19de4' : '#dce5fb' }))
export function searchScenery(query = '', category = '') {
  const clean = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  const terms = clean(query).trim().split(/\s+/).filter(Boolean)
  return SCENERY_PRESETS.filter(p => (!category || p.family === category) && terms.every(term => clean(p.name + ' ' + SCENERY_CATEGORIES.find(c => c.id === p.family).name).includes(term)))
}
const bounded = (value, min, max, fallback) => {
  const number = Number(value)
  return Number.isFinite(number) ? Math.max(min, Math.min(max, number)) : fallback
}
export function normalizeScenery(value = {}) {
  const preset = SCENERY_PRESETS.find(p => p.kind === value.kind) || SCENERY_PRESETS[0]
  const columns = Math.round(bounded(value.columns, 1, 12, 1))
  return {
    version: 1, kind: preset.kind,
    columns, rows: Math.round(bounded(value.rows, 1, Math.min(20, Math.floor(160 / columns)), 1)),
    gapX: bounded(value.gapX, 0, 120, 20), gapY: bounded(value.gapY, 0, 120, 20),
    aisle: columns > 1 ? bounded(value.aisle, 0, 240, 0) : 0,
    vertical: value.vertical === true,
    color: /^#[\da-f]{6}$/i.test(value.color || '') ? value.color : preset.color,
    wood: value.wood === 'dark' ? 'dark' : 'honey',
    striped: value.striped !== false,
    showNumbers: value.showNumbers === true,
    startNumber: Math.round(bounded(value.startNumber, 1, 9999, 1)),
    showLabel: value.showLabel === true,
  }
}
export function sceneryLayout(value) {
  const config = normalizeScenery(value)
  const preset = SCENERY_PRESETS.find(p => p.kind === config.kind)
  const header = config.showLabel ? 36 : 0
  const width = 16 + config.columns * preset.w + (config.columns - 1) * config.gapX + config.aisle
  const height = 16 + header + config.rows * preset.h + (config.rows - 1) * config.gapY
  const items = Array.from({ length: config.rows * config.columns }, (_, i) => {
    const col = i % config.columns, row = Math.floor(i / config.columns)
    return { x: 8 + col * (preset.w + config.gapX) + (col >= Math.ceil(config.columns / 2) ? config.aisle : 0),
      y: 8 + header + row * (preset.h + config.gapY), number: config.startNumber + i }
  })
  return { config, preset, items, width, height, w: config.vertical ? height : width, h: config.vertical ? width : height }
}
export function isScenery(object) {
  return object?.type === 'scenery' && SCENERY_PRESETS.some(p => p.kind === object.scenery?.kind)
}
export function createSceneryObject(config, { id, name, bounds, zIndex = 2000 }) {
  const layout = sceneryLayout(config)
  const scale = Math.min(1, Math.max(1, bounds.width) / layout.w, Math.max(1, bounds.height) / layout.h)
  const w = layout.w * scale, h = layout.h * scale
  return { id, type: 'scenery', category: 'object', shape_type: 'rect',
    name, label: name, show_label: false, scenery: layout.config,
    x: bounds.x + (bounds.width - w) / 2, y: bounds.y + (bounds.height - h) / 2,
    w, h, rx: 2, shadow: 'none', z_index: zIndex }
}


export const SCENERY_LIBRARY_LIMIT = 50
export function sceneryLibraryKey(owner = '') {
  return 'fomo:venue-scenery-library:v1:' + encodeURIComponent(String(owner || 'local'))
}
export function parseSceneryLibrary(raw) {
  if (!raw) return []
  const data = JSON.parse(raw)
  if (data?.version !== 1 || !Array.isArray(data.items)) throw new Error('El formato de la biblioteca no es compatible.')
  const seen = new Set()
  return data.items.slice(0, SCENERY_LIBRARY_LIMIT).flatMap(item => {
    if (!item || typeof item.id !== 'string' || !item.id || item.id.length > 100 || seen.has(item.id) || typeof item.name !== 'string' || !item.name.trim() || !SCENERY_PRESETS.some(p => p.kind === item.scenery?.kind)) return []
    seen.add(item.id)
    return [{ id: item.id, name: item.name.trim().slice(0, 80), scenery: normalizeScenery(item.scenery) }]
  })
}
export function readSceneryLibrary(storage, key) {
  return parseSceneryLibrary(storage.getItem(key))
}
export function writeSceneryLibrary(storage, key, items) {
  if (items.length > SCENERY_LIBRARY_LIMIT) throw new Error('Tu biblioteca admite hasta 50 composiciones. Elimina una para guardar otra.')
  const clean = parseSceneryLibrary(JSON.stringify({ version: 1, items }))
  storage.setItem(key, JSON.stringify({ version: 1, items: clean }))
  return clean
}
